import React from 'react'
//@ts-ignore
import dashboard from '../../assets/images/dashboard.png';
const DashobardIcon = () => {
  return (
    <img src={dashboard} alt="dashboard" height="25" />
  )
}

export default DashobardIcon